const CODE_MAX_LENGTH = 32;

/**
 * A new zone's code from its name: "Bidco Oil Refinery" → `bidco_oil_refinery`, the shape the seeded codes
 * take. Only suggested while the code hasn't been typed; rate lines key on it, so an existing zone's is never rewritten.
 */
export function codeFromName(name: string): string {
  return name
    .normalize('NFKD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '')
    .slice(0, CODE_MAX_LENGTH)
    .replace(/_+$/, '');
}
